import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import { Icon } from '@/components/atoms/Icon/Icon';
import { Icons } from '../Icon';

export const Chip = ({
  label,
  isSelected = false,
  isRectangle = false,
  onClick,
  icon,
  isDisabled = false,
}: ChipProps) => {
  const isButton = !!onClick;
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: sp[8],
        background: '#f2ede3',
        borderRadius: !isRectangle ? '99999px' : 0,
        p: `${sp[8]} ${sp[16]}`,
        color: '#404042',
        userSelect: 'none',
        whiteSpace: 'nowrap',
        transitionDuration: '200ms',
        ...(isButton &&
          !isSelected && {
            cursor: 'pointer',
            '&:hover': { background: '#404042', color: '#ffffff' },
          }),
        ...(isSelected && {
          cursor: 'default',
          pointerEvents: 'none',
          background: '#404042',
          color: '#ffffff',
        }),
        ...(isDisabled && {
          background: '#f2ede3',
          color: '#d9d9d9',
          cursor: 'default',
        }),
      }}
    >
      {icon && <Icon icon={icon} />}
      <Box sx={{ typography: 'bodySm' }}>{label}</Box>
    </Box>
  );
};

export interface ChipProps {
  label: string;
  onClick?: () => void;
  isSelected?: boolean;
  icon?: Icons;
  to?: string;
  replace?: boolean;
  isDisabled?: boolean;
  isRectangle?: boolean;
}

Chip.displayName = 'Chip';

export default Chip;
